import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const PreferredName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="preferredName"
      label="Preferred Name"
      rules={[
        {
          pattern: /^[a-zA-Z ]*$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input
        showCount
        maxLength={64}
        prefix={<UserOutlined className="form-item-icon" />}
        placeholder="Preferred Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default PreferredName;
